import { Module } from 'vuex'
import { RootState } from '@/store'
import mutations from '@/store/user/mutations'
import { path } from '@/store/user/types'
import { mutation } from '@/utils/mutation'
import state, { IUserState } from '@/store/user/state'

export * from '@/store/user/state'

export const store: Module<IUserState, RootState> = {
  state,
  mutations: mutation(mutations, path)
}
